import React from 'react'

const SuccessIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2C10.0222 2 8.08879 2.58649 6.4443 3.6853C4.79981 4.78412 3.51809 6.3459 2.76121 8.17316C2.00433 10.0004 1.8063 12.0111 2.19215 13.9509C2.578 15.8907 3.53041 17.6725 4.92894 19.0711C6.32746 20.4696 8.10929 21.422 10.0491 21.8078C11.9889 22.1937 13.9996 21.9957 15.8268 21.2388C17.6541 20.4819 19.2159 19.2002 20.3147 17.5557C21.4135 15.9112 22 13.9778 22 12C21.9972 9.34869 20.9427 6.80678 19.068 4.93202C17.1932 3.05727 14.6513 2.0028 12 2ZM16.3904 10.2365L11.0058 15.6212C10.9343 15.6927 10.8495 15.7494 10.7561 15.7881C10.6627 15.8268 10.5626 15.8468 10.4615 15.8468C10.3605 15.8468 10.2604 15.8268 10.167 15.7881C10.0736 15.7494 9.98875 15.6927 9.91731 15.6212L7.60962 13.3135C7.46528 13.1691 7.38419 12.9734 7.38419 12.7692C7.38419 12.5651 7.46528 12.3693 7.60962 12.225C7.75396 12.0807 7.94972 11.9996 8.15385 11.9996C8.35798 11.9996 8.55374 12.0807 8.69808 12.225L10.4615 13.9894L15.3019 9.14808C15.3734 9.07661 15.4582 9.01991 15.5516 8.98123C15.645 8.94256 15.7451 8.92265 15.8462 8.92265C15.9472 8.92265 16.0473 8.94256 16.1407 8.98123C16.2341 9.01991 16.3189 9.07661 16.3904 9.14808C16.4619 9.21954 16.5185 9.30439 16.5572 9.39777C16.5959 9.49115 16.6158 9.59123 16.6158 9.69231C16.6158 9.79338 16.5959 9.89346 16.5572 9.98684C16.5185 10.0802 16.4619 10.1651 16.3904 10.2365Z"
      fill="#439F6E"
    />
  </svg>
)

export default SuccessIcon
